import Pathicon from "@pathwright/web/src/modules/pathicon/Pathicon"
import { pascalCase } from "change-case"
import classnames from "classnames"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { getEnv } from "../utils/env"
import "./Pathicon.css"
import "./font/pathicons.css"
import * as Pathicons from "./pathicons"
import Icon from "./pathicons/Icon"

// List of legacy icons
const legacyPathiconCSSClassNames = [
  "mail-o",
  "horspacingnormal",
  "horspacingtight",
  "horspacingwide",
  "styles",
  "vertspacingnormal",
  "vertspacingtight",
  "vertspacingwide",
  "homepage-design",
  "homepage-learn",
  "homepage-manage",
  "homepage-teach",
  "bookmark",
  "annotation",
  "reports-activity",
  "fully-brand",
  "control-access",
  "cloud-hosting",
  "mobile-first",
  "beta",
  "integrations-support",
  "support-compliance",
  "multi-tenant",
  "flexible-pricing",
  "partner-services",
  "sso",
  "playback-15back",
  "playback-15forward",
  "playback-fastforward",
  "playback-pause",
  "playback-play",
  "playback-rewind",
  "playback-tinyloud",
  "playback-tinymute",
  "playback-trackback",
  "playback-trackforward",
  "role-observer",
  "arrowdiagbottomleft",
  "arrowdiagbottomright",
  "arrowdiagtopleft",
  "arrowdiagtopright",
  "heart-fill",
  "watch-alt-fill",
  "layout",
  "blocks",
  "glasses",
  "newwindow",
  "airplane",
  "multiselect",
  "triangleup",
  "triangledown",
  "flip",
  "zoomin-fill",
  "zoomin",
  "zoomout-fill",
  "zoomout",
  "heart",
  "exitfullscreen",
  "heading",
  "text",
  "carousel",
  "quote",
  "markdown",
  "fullscreen",
  "arrowdown-o-fill",
  "arrowleft-o-fill",
  "arrowright-o-fill",
  "arrowup-o-fill",
  "check-o-fill",
  "commercealt-fill",
  "css-fill",
  "css",
  "domain-fill",
  "domain",
  "statusallgood-fill",
  "statusallgood",
  "statuscaution-fill",
  "statuscaution",
  "statusinfo-fill",
  "statusinfo",
  "other-fill",
  "other",
  "highered-fill",
  "highered",
  "teamtraining-fill",
  "communitynav-fill",
  "librarynav-fill",
  "ministrychurch-fill",
  "k12classroom-fill",
  "prodevelopment-fill",
  "coachingtutoring-fill",
  "curriculumpub-fill",
  "customertraining-fill",
  "integration-fill",
  "integration",
  "snippet-fill",
  "snippet",
  "support-fill",
  "support",
  "theme-fill",
  "theme",
  "communitynav",
  "librarynav",
  "coachingtutoring",
  "curriculumpub",
  "customertraining",
  "k12classroom",
  "ministrychurch",
  "prodevelopment",
  "teamtraining",
  "role-editor",
  "role-learner",
  "role-manager",
  "role-member",
  "role-moderator",
  "role-teacher",
  "paste-fill",
  "copy-fill",
  "paste",
  "copy",
  "arrowdownsmall",
  "arrowleftsmall",
  "arrowrightsmall",
  "arrowupmall",
  "password",
  "rocket",
  "settings-app",
  "peopleboot-app",
  "peopleedit-app",
  "peoplesettings-app",
  "filter",
  "toolbox-fill",
  "toolbox",
  "avatarlock-fill",
  "avatarlock",
  "notebookadd-app",
  "notebooklock-app",
  "peopleadd-app",
  "peoplelock-app",
  "scheduleadd-app",
  "schedulelock-app",
  "cancel-fill",
  "add-fill",
  "switch",
  "attend-fill",
  "audio-fill",
  "avatar-fill",
  "bell-fill",
  "commercetag-fill",
  "commercetag",
  "edit-fill",
  "group-fill",
  "groupadd-fill",
  "lightbulb-fill",
  "lightbulb",
  "listen-fill",
  "locked-fill",
  "lockedsmall-fill",
  "mail-fill",
  "pathcollapse-fill",
  "pathcollapse",
  "pathexpand-fill",
  "pathexpand",
  "people-app",
  "people-fill",
  "read-fill",
  "reply-fill",
  "search-fill",
  "settings-fill",
  "submit-fill",
  "teach-fill",
  "teach",
  "time-fill",
  "tip-fill",
  "todo-fill",
  "trashcan-fill",
  "unlocked-fill",
  "unlockedsmall-fill",
  "view-fill",
  "watch-fill",
  "analytics-app",
  "commerce-app",
  "notebook-app",
  "radar-app",
  "review-app",
  "schedule-app",
  "tip",
  "group-add",
  "group",
  "commerce",
  "commercealt",
  "lockedsmall",
  "public",
  "unlockedsmall",
  "subscriptionplan-cancel",
  "subscriptionplan-pause",
  "subscriptionplan",
  "password-change",
  "billing-change",
  "billing",
  "discussion",
  "add-mini",
  "edit",
  "upload",
  "bell",
  "link",
  "filearchive",
  "fileaudio",
  "filecode",
  "filedoc",
  "fileimage",
  "filevideo",
  "watch-alt",
  "moveupdown",
  "moveupdownalt",
  "facebook-o",
  "gridview-lgovals",
  "gridview-smovals",
  "undo-o",
  "undo",
  "achievement",
  "moneyback",
  "lifetimeaccess",
  "moderated",
  "responsive-alt",
  "responsive",
  "socialshare",
  "star1",
  "star2",
  "star3",
  "star4",
  "star5",
  "star6",
  "star7",
  "star8",
  "star9",
  "starempty",
  "starfull",
  "todo-alt",
  "expert",
  "googleplus-o",
  "linkedin-o",
  "pinterest-o",
  "rss-o",
  "twitter-o",
  "vimeo-o",
  "youtube-o",
  "image",
  "page",
  "note",
  "notes",
  "chevrondowndouble",
  "chevronleftdouble",
  "chevronrightdouble",
  "chevronupdouble",
  "content-collapse",
  "content-expand",
  "trashcan",
  "move",
  "dock-bottom",
  "dock-side",
  "gridview-large",
  "gridview-small",
  "listview-basic",
  "listview-fancy",
  "print",
  "search",
  "mail",
  "settings",
  "reply",
  "reply-o",
  "ellipses",
  "chevronup",
  "chevronup-o",
  "chevronright",
  "chevronright-o",
  "chevronleft",
  "chevronleft-o",
  "chevrondown",
  "chevrondown-o",
  "chatfollow",
  "chat",
  "tracks",
  "subscription",
  "mobile",
  "metrics",
  "media",
  "marketplace",
  "integrations",
  "feedback",
  "curriculum",
  "community",
  "cloud",
  "builder",
  "brand",
  "people",
  "people-o",
  "path",
  "path-o",
  "info",
  "info-o",
  "avatar",
  "avatar-o",
  "take",
  "watch",
  "view",
  "unlocked",
  "unlocked-o",
  "to-do",
  "time",
  "submit",
  "share",
  "read",
  "locked",
  "locked-o",
  "location",
  "listen",
  "listback",
  "list",
  "download",
  "check",
  "check-o",
  "cancel",
  "cancel-o",
  "audio",
  "attend",
  "survey",
  "arrowup",
  "arrowup-o",
  "arrowright",
  "arrowright-o",
  "arrowleft",
  "arrowleft-o",
  "arrowdown",
  "arrowdown-o",
  "add",
  "add-o"
]

const PathiconLegacy = ({ iconClassName, icon, style, ...rest }) => {
  const ref = React.useRef(null)

  useEffect(() => {
    if (ref.current && !getEnv("production")) {
      console.warn(
        `Missing icon "${icon}". Attempting to use legacy Pathicon, which is not recommended!"`,
        ref.current
      )
    }
  }, [ref.current])

  return <i ref={ref} className={iconClassName} style={style} {...rest} />
}

const PathiconExpensive = ({
  icon,
  rotate,
  flip,
  style,
  className,
  fill,
  ...rest
}) => {
  if (typeof icon !== "string") return null

  const iconComponentName = pascalCase(icon)
  // This dynamic import throws a styled-components warning about creating styled component dynamically.
  // const IconComponent = require(`./pathicons`)[iconComponentName]
  const IconComponent = Pathicons[iconComponentName]

  const iconClassName = classnames(
    "Pathicon",
    {
      [`pwai-${icon.toLowerCase()}`]: !IconComponent,
      [`pathicon-${icon.toLowerCase()}`]: !!IconComponent,
      [`Pathicon--rotate-${rotate}`]: rotate,
      [`Pathicon--flip-${flip}`]: flip
    },
    className
  )

  if (IconComponent) {
    return (
      <IconComponent
        className={iconClassName}
        rotate={rotate}
        flip={flip}
        fill={fill}
        style={style}
        {...rest}
      />
    )
  }

  if (legacyPathiconCSSClassNames.includes(icon)) {
    return (
      <PathiconLegacy
        iconClassName={iconClassName}
        icon={icon}
        style={style}
        {...rest}
      />
    )
  }

  return (
    <Icon
      className={iconClassName}
      rotate={rotate}
      flip={flip}
      fill={fill}
      style={style}
      {...rest}
    >
      <Pathicon icon={icon} />
    </Icon>
  )
}

PathiconExpensive.displayName = "Pathicon"

PathiconExpensive.propTypes = {
  icon: PropTypes.string,
  rotate: PropTypes.oneOf([0, 45, 90, 135, 180, 225, 270, 315, 360]),
  flip: PropTypes.oneOf(["horizontal", "vertical"])
}

export default PathiconExpensive
